module.exports = __webpack_public_path__ + "images/emoji/massage.c3a164f85b816bf8c6e0.png";